module.exports = __webpack_public_path__ + "static/macrame-3f3e78c96a084dd94897e02239616454.png";